import { RegistryObject } from "@mcleod/core";
import { BehaviorTypes } from "./BehaviorTypes";

/**
 * Behaviors define methods that modify a component’s functionality based on the registered behavior class.
 * They enable us to define device-specific behavior (desktop, tablet, or mobile) and are registered via BehaviorTypes.
 */
export abstract class Behavior extends RegistryObject {
    protected constructor() { super(); }

    private static createInstance<T extends Behavior>(this: { new(): T }): T {
        return new this();
    }

    public static register<T extends Behavior>(this: { prototype: T } & typeof Behavior): void {
        const instance = (this as any).createInstance();
        BehaviorTypes.register(instance);
    }
}
